import BillingPublisherService from 'respona_api/generated/billing-publisher_pb_service';

const service = (function () {
  let instance = null;

  return {
    getInstance: (): BillingPublisherService.BillingPublisherApiServiceClient => {
      if (!instance) {
        // @ts-ignore
        instance = new BillingPublisherService.BillingPublisherApiServiceClient(API_HOST);
      }

      return instance;
    },
  };
})();

export default service;
